import { useEffect, useState } from "react";
import { useSubscription } from "@apollo/client";
import { useLocation } from "react-router-dom";
import { ChatContext } from "src/context/chats";
import audioSrc from "src/assets/sounds/light-hearted-message-tone.mp3";
import useSource from "src/utils/shared/useSource";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";
import INBOX_DETAIL_ADDED from "src/graphql/subscriptions/chat/inboxdetailadded";

const NewChatListener = () => {
  const { agentId } = useActiveUserDetail();

  const [audio] = useState(new Audio(audioSrc));

  const { topTabValue } = ChatContext();
  const { pathname } = useLocation();

  const source = useSource(topTabValue);

  const { data: InboxDetailAddedSubscriptionResult } =
    useSubscription(INBOX_DETAIL_ADDED);

  useEffect(() => {
    if (InboxDetailAddedSubscriptionResult?.inboxdetailadded) {
      const { inboxdetailadded } = InboxDetailAddedSubscriptionResult;

      // conditions
      const isSameAgent = agentId === inboxdetailadded.agentId;

      const isSameSource =
        source === inboxdetailadded.source || source === "all";

      const isTabInactive = document.visibilityState !== "visible"; // 👈 this

      const isNotOnChatScreen = !pathname.startsWith("/chats");

      if (inboxdetailadded && isSameAgent && isSameSource) {
        if (isTabInactive || isNotOnChatScreen) {
          audio.play();
        }
      }
    }
  }, [InboxDetailAddedSubscriptionResult]);
  return null;
};

export default NewChatListener;
